import join from 'lodash-es/join'

const iterateArray = (array, word = 'or') =>
  join(
    array.map((bedroom, index) => {
      let bedroomCount = array.length

      if (index === bedroomCount - 2 || bedroomCount === 1) {
        return bedroom
      }
      if (index === bedroomCount - 1) {
        return `${word} ${bedroom}`
      }
      return `${bedroom},`
    }),
    ' '
  )

export default iterateArray
